import { motion } from 'motion/react';
import styles from './CarouselAvatars.module.css';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { iconsSources } from 'helpers/icons';

export const CarouselAvatars = ({ messages }) => {
  const errorHandler = (e, message) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <motion.div
      className={styles.carouselWrapper}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <TransitionGroup className={styles.carousel}>
        {messages.length > 0 &&
          messages.map((item, i) => (
            <CSSTransition
              key={item.UUID}
              timeout={400}
              classNames={{
                enter: styles['position-enter'],
                enterActive: styles['position-enter-active'],
                exit: styles['position-exit'],
                exitActive: styles['position-exit-active'],
              }}
            >
              <div className={styles.carouselItem} key={item.id}>
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  className={styles.avatarBlock}
                >
                  <div
                    className={styles.avatarBg}
                    style={{
                      background: `url(${iconsSources[item.message?.channel]}) center/cover no-repeat`,
                    }}
                  />
                  <img
                    onError={(e) => errorHandler(e, item.message)}
                    src={item.message.image}
                  />
                </motion.div>
              </div>
            </CSSTransition>
          ))}
      </TransitionGroup>
    </motion.div>
  );
};
